import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { NavigationSelectorComponent } from './NavigationSelectorComponent';

export const NavigationSelectorExtension = scaffolderPlugin.provide(
    createScaffolderFieldExtension({
        name: 'NavigationSelector',
        component: NavigationSelectorComponent,
    }),
)